<svelte:options runes={false} />
<script>
  // Join-discovery (U15/KTD12): running strategies in the user's member orgs that their selected org does NOT
  // yet participate in. Joining issues an add-org adjustment against that strategy (subject to the same auth +
  // live-ceiling rules as a single-strategy add-org, U7/KTD6a) — async, so it shows the Pending lifecycle via
  // the parent's adjustment map. A read-only participant sees the list but Join is owner/admin-gated server-side.
  import { createEventDispatcher } from 'svelte';
  import SymbolUniverse from '../shared/SymbolUniverse.svelte';

  const dispatch = createEventDispatcher();

  export let strategies = [];   // DiscoverableStrategy[] { strategyId, strategy, symbols, ownerUserId }
  export let busy = false;

  // Per-row starting cash for the join (paper default $1M; live re-checks the ceiling server-side).
  let cash = {};
  function cashFor(id) { return cash[id] ?? 1_000_000; }

  function join(s) {
    const amount = Number(cashFor(s.strategyId));
    if (!(amount > 0)) return;
    dispatch('join', { strategyId: s.strategyId, startingCash: amount });
  }

</script>

<div class="at-discovery">
  <h4 class="at-discovery-head">Discover strategies to join</h4>
  {#if strategies.length === 0}
    <p class="empty-state-description">No running strategies in your organizations available to join right now.</p>
  {:else}
    <ul class="at-discovery-list">
      {#each strategies as s (s.strategyId)}
        <li class="at-discovery-item">
          <div class="at-discovery-info">
            <span class="at-discovery-name">{s.strategy}</span>
            <SymbolUniverse symbols={s.symbols} variant="inline" dense label="Pairs" />
          </div>
          <div class="at-discovery-join">
            <input type="number" min="0" step="1000" class="form-input at-discovery-cash"
              value={cashFor(s.strategyId)} on:input={(e) => (cash[s.strategyId] = e.target.value)}
              aria-label={`Starting cash to join ${s.strategy}`} />
            <button type="button" class="btn btn-sm btn-primary" disabled={busy} on:click={() => join(s)}>Join</button>
          </div>
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .at-discovery-head { margin: 0 0 0.5rem; font-size: 0.9rem; font-weight: 700; color: var(--text-primary, #e8e9ea); }
  .at-discovery-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 0.4rem; }
  .at-discovery-item { display: flex; align-items: center; justify-content: space-between; gap: 1rem; padding: 0.5rem 0.75rem; border: 1px solid var(--border-subtle, #1e1f22); border-radius: 6px; background: var(--surface-1, rgba(255, 255, 255, 0.02)); }
  .at-discovery-info { display: flex; flex-direction: column; gap: 0.2rem; flex: 1 1 0; min-width: 0; }
  .at-discovery-name { font-weight: 600; color: var(--text-primary, #e8e9ea); }
  .at-discovery-join { display: flex; align-items: center; gap: 0.4rem; }
  .at-discovery-cash { width: 8rem; }
</style>
